/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringListResponse
 */
export interface StringListResponse {
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof StringListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof StringListResponse
     */
    error?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringListResponse
     */
    data?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof StringListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof StringListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StringListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the StringListResponse interface.
 */
export function instanceOfStringListResponse(value: object): value is StringListResponse {
    return true;
}

export function StringListResponseFromJSON(json: any): StringListResponse {
    return StringListResponseFromJSONTyped(json, false);
}

export function StringListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'data': json['data'] == null ? undefined : json['data'],
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function StringListResponseToJSON(json: any): StringListResponse {
    return StringListResponseToJSONTyped(json, false);
}

export function StringListResponseToJSONTyped(value?: StringListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
        'data': value['data'],
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

